import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { GetPageAuthorityFn } from "../../Common/authority";
import { GetLeaveHistoryActionPermission } from "../../Common/authority";
import CssClass from "../../Styles/common.module.css";
import LeaveApprove from "../../Components/History/Leave/LeaveApprove";
import LeaveRejected from "../../Components/History/Leave/LeaveRejected";
import LeaveCancel from "../../Components/History/Leave/LeaveCancel";
import AttachmentReminder from "../../Components/History/Leave/AttachmentReminder";
import AttachmentUpload from "../../Components/History/Leave/AttachmentUpload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCalendarCheck, faCalendarXmark, faDownload, faUpload } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { FcImageFile } from "react-icons/fc";

const PAGE_NAME = "LeaveHistory.js_";
const MODULE_ID = "WEB_HIS_001";

const LeaveHistory = (props) => {
  document.title = common.c_TITLE + " - LeaveHistory";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [allData, setAllData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]);
  const [startDateFilter, endDateFilter] = dateRangeFilter;
  const [showApprove, setShowApprove] = useState(false);
  const [showRejected, setShowRejected] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showReminder, setShowReminder] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [selectedLeave, setSelectedLeave] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    USERNAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
    STATUS_DESC: { value: null, matchMode: FilterMatchMode.CONTAINS },
    LEAVE_TYPE: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });
  
  const [viewAuthority, setViewAuthority] = useState({
    APPROVAL: "N",
    CANCELLATION: "N",
    REJECT: "N",
    VIEW: "N",
  });
  

  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
      let promise = GetLeaveHistoryActionPermission(userId, MODULE_ID);
      promise.then(
        (result) => {
          setViewAuthority(result);
        },
        (error) => {
          setViewAuthority({
            APPROVAL: "N",
            CANCELLATION: "N",
            REJECT: "N",
            VIEW: "N",
          });
          common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
          toast.error(error);
        }
      );
    }, [actionAuthority, userId])


  useEffect(() => {
      if (!viewAuthority) return;
      let functionName = "";
      try {
        functionName = "Get All Leave Application History";

        setLoading(true);
        setLoadingText("Getting Record, please wait...");
        const listItems = [];
        const userIds = viewAuthority.VIEW === "Y" ? "" : userId;
                
        var newStartDate = "";
        var newEndDate = "";
        if (startDateFilter === null && endDateFilter === null) {
          newStartDate = "";
          newEndDate = "";
        } else if (startDateFilter !== null && endDateFilter === null) {
          newStartDate = common.c_Dis_DateTime(startDateFilter).val;
          newEndDate = "";
        } else {
          newStartDate = common.c_Dis_DateTime(startDateFilter).val;
          newEndDate = common.c_Dis_DateTime(endDateFilter).val;
        }
        
        http
          .get(
            "api/leaveHistory/GetLeaveList?_sysUser=" + userIds +
            "&_startDateFilter=" +
            newStartDate +
            "&_endDateFilter=" +
            newEndDate,{ timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                const submittedDate = new Date(data.SUBMIT_DATETIME);
                const formattedSubmittedDate =
                  submittedDate.toLocaleDateString('en-GB') + ' ' + submittedDate.toLocaleTimeString('en-GB', {
                    hour12: true,
                    hour: '2-digit',
                    minute: '2-digit',
                  }).toUpperCase();

                const updateDate = new Date(data.UPDATE_DATETIME);
                const formattedUpdateDate =
                  updateDate.toLocaleDateString('en-GB') + ' ' + updateDate.toLocaleTimeString('en-GB', {
                    hour12: true,
                    hour: '2-digit',
                    minute: '2-digit',
                  }).toUpperCase();

                listItems.push({
                  key: data.LEAVE_MST_ID,
                  LEAVE_MST_ID: data.LEAVE_MST_ID,
                  USER_MST_GUID: data.USER_MST_GUID,
                  USERNAME: data.USERNAME,  
                  STATUS:data.STATUS,
                  STATUS_DESC:data.STATUS_DESC,
                  SUBMIT_DATETIME:formattedSubmittedDate,
                  LEAVE_TYPE: data.LEAVE_TYPE,
                  LEAVE_SESSION: data.LEAVE_SESSION,
                  START_DATE: new Date(data.START_DATE).toLocaleDateString("en-GB") || "",
                  END_DATE: new Date(data.END_DATE).toLocaleDateString("en-GB") || "",
                  TOTAL_DAYS: data.TOTAL_DAYS,
                  REASON: data.REASON,
                  ATTACHMENT_ID: data.ATTACHMENT_ID,
                  FILENAME_ORI: data.FILENAME_ORI,
									COVER_NAME: data.COVER_NAME,
									REMARK: data.REMARK,
                  SUBMIT_NAME: data.SUBMIT_NAME,
									UPDATE_DATETIME: formattedUpdateDate,
                  UPDATE_NAME: data.UPDATE_NAME,
                });
              });
            }
            setAllData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting record. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
      } catch (err) {
        toast.error("Error on getting record. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }, [reload, viewAuthority, userId]);

  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Status list";
      const listItems = [];
      http
        .get("api/leaveHistory/GetStatus?_sysUser=" + userId, { timeout: 100000 })
        .then((response) => {
        const listItems = response.data.map(dayType => ({
          key: dayType.CATEGORY_TYPE_MST_ID,
          value: dayType.CATEGORY_TYPE_NAME,
          label: `${dayType.CATEGORY_TYPE_NAME}`
        }));
        setStatusList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting status list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting status list. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);

  const statusFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statusList}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select status"
      />
    );
  };

  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Leave Type list";
      const listItems = [];
      http
        .get("api/leaveHistory/GetLeaveType?_sysUser=" + userId, { timeout: 100000 })
        .then((response) => {
        const listItems = response.data.map(dayType => ({
          key: dayType.CATEGORY_TYPE_MST_ID,
          value: dayType.CATEGORY_TYPE_NAME,
          label: `${dayType.CATEGORY_TYPE_NAME}`
        }));
        setLeaveTypeList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting leave type list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting leave type list. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);

  const leaveTypeFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={leaveTypeList}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select leave type"
      />
    );
  };

  //#region Event Handlers
  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const showApproveModal = (e, row) => {
    setShowApprove(!showApprove);
    setEditData(row);
  };

  const hideApproveModal = () => {
    setShowApprove(!showApprove);
    setEditData(null);
  };

  const showRejectedModal = (e, row) => {
    setShowRejected(!showRejected);
    setEditData(row);
  };

  const hideRejectedModal = () => {
    setShowRejected(!showRejected);
    setEditData(null);
  };

  const showCancelModal = (e, row) => {
    setShowCancel(!showCancel);
    setEditData(row);
  };

  const hideCancelModal = () => {
    setShowCancel(!showCancel);
    setEditData(null);
  };

  const showReminderModal = (e, row) => {
    setShowReminder(!showReminder);
    setEditData(row);
  };

  const hideReminderModal = () => {
    setShowReminder(!showReminder);
    setEditData(null);
  };

  const showUploadModal = (e, row) => {
    setShowUpload(!showUpload);
    setEditData(row);
  };

  const hideUploadModal = () => {
    setShowUpload(!showUpload);
    setEditData(null);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
  
    if (!_filters['global']) {
      _filters['global'] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    }
  
    _filters['global'].value = value;
  
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Leave History</span>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
            className="table-search-input"
            style={{ height: '40px', fontSize: '0.9rem' }}
          />
        </IconField>
      </div>
    );
  };
  
  const HighlightCell = ({ text, keyword }) => {
    if (!keyword || !text) return text;
  
    const regex = new RegExp(`(${keyword})`, "gi");
    const parts = text.split(regex);
  
    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === keyword.toLowerCase() ? (
            <span key={i} className="highlight-keyword">{part}</span>
          ) : (
            part
          )
        )}
      </>
    );
  };
      
  const TruncatedText = ({ text = '', maxLength = 0 }) => {
    const [expanded, setExpanded] = useState(false);
    
    if (!text) return null;
    
    const isLong = text.length > maxLength;
    const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + '...';
    
    return (
      <div>
        <span>{displayText}</span>
        {isLong && (
          <span
            onClick={() => setExpanded((prev) => !prev)}
            style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px' }}
          >
            {expanded ? 'Show less' : 'Read more'}
          </span>
        )}
      </div>
    );
  };

  const verifyAttachment = (e, rowData) => {
    if(rowData.LEAVE_TYPE === "Medical" && rowData.ATTACHMENT_ID === null) {
      showReminderModal(e, rowData);
    } else {
      showApproveModal(e, rowData)
    }
  };

  const onImageHandler = (e, rowData) => {
    const attachmentId = rowData.ATTACHMENT_ID;

    window.open(
      common.c_getApiUrl() +
        "api/leaveHistory/ExportImage?_sysUser=" +
        userId +
        "&_attachmentId=" +
        attachmentId
    );
  };

  const onExcelHandler = (e, rowData) => {
    const selectedLeaveId =
      rowData.LEAVE_MST_ID !== undefined
        ? rowData.LEAVE_MST_ID
        : "";
    window.open(
      common.c_getApiUrl() +
        "api/leaveHistory/ExportExcel?_leaveId=" +
        selectedLeaveId +
        "&_sysUser=" +
        userId
    );
  };
  //#endregion

  return (
    <>
      <div style={{ margin: "8px 8px 0", padding: "5px 10px" }}>
        <table className="profileTable" style={{  width: '100%', border: '1px solid #ccc', backgroundColor: '#ffffff' }}>
          <tr>
            <td style={{ verticalAlign: "middle", width: "10%" }}>Leave Date (From-To)</td>
            <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
            <td style={{ verticalAlign: "middle", width: "35%" }}>
              <Comp.DateTimePicker 
                id="DATE_RANGE_FILTER"
                selectsRange
                onChange={(dates) => setDateRangeFilter(dates)}
                startDate={startDateFilter}
                endDate={endDateFilter}
                autoComplete="off"
              />
            </td>
          </tr>
        </table>
      </div>
      <div className={CssClass.btnWrapperTwo}>
        <Comp.Button id="btnSearch" type="general" style={{width: '140px'}} onClick={onReloadHandler}>
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          <span>&nbsp; SEARCH</span>
        </Comp.Button>
      </div>
      <div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
        <div style={{ width: "100%" }}>
          <DataTable value={allData} dataKey="LEAVE_MST_ID" header={renderHeader()} globalFilter={globalFilterValue} globalFilterFields={['USERNAME', 'STATUS', 'LEAVE_TYPE']} filters={filters} filterDisplay="row" 
            onFilter={(e) => { 
              const newFilters = e.filters; 
              setFilters(newFilters); 
              const globalKeyword = newFilters.global?.value || '';
              const updated = allData.map(item => ({ ...item, __FILTER_KEYWORD__: { USERNAME: newFilters.USERNAME?.value || globalKeyword, STATUS: newFilters.STATUS?.value || globalKeyword, LEAVE_TYPE: newFilters.LEAVE_TYPE?.value || globalKeyword }})); 
              setAllData(updated); 
            }}
            selectionMode="multiple" selection={selectedLeave} onSelectionChange={(e) => setSelectedLeave(e.value)}
            loading={loading} removableSort emptyMessage="No leave found." first={currentPage * rowsPerPage}
            paginator rows={rowsPerPage} onPage={(e) => { setCurrentPage(e.page); setRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
            scrollable scrollHeight="500px" showGridlines className="datatable" tableStyle={{ minWidth: '80rem' }}
          >
            <Column header="Action"
                body={(rowData) => (
                  <div style={{ textAlign: "left", width: "180px", marginLeft: "8px" }} className={CssClass.tdBtnActionWrapperTwo}>
                    {(viewAuthority.APPROVAL === "Y" && rowData.STATUS === "2F917D27-2274-4509-9B9C-1A86FFFB6A45")&& (
                      <span title="Approve">
                        <Comp.Button
                          id="btnApprove"
                          type="general"
                          onClick={(e) => verifyAttachment(e, rowData)}
                          style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                        >
                          <FontAwesomeIcon icon={faCalendarCheck} />
                        </Comp.Button>
                      </span>
                    )}
                    {(viewAuthority.REJECT === "Y" && rowData.STATUS === "2F917D27-2274-4509-9B9C-1A86FFFB6A45") && (
                      <span title="Reject">
                        <Comp.Button
                          id="btnReject"
                          type="general"
                          onClick={(e) => showRejectedModal(e, rowData)}
                          style={{ width: "50px", height: "35px", backgroundColor: "#d40b0b" }}
                        >
                          <FontAwesomeIcon icon={faCalendarXmark} />
                        </Comp.Button>
                      </span>
                    )}
                    {(viewAuthority.CANCELLATION === "Y" && rowData.STATUS === "E29288AB-B30C-4039-9365-0324498F1352") && (
                      <span title="Cancel">
                        <Comp.Button
                          id="btnCancel"
                          type="general"
                          onClick={(e) => showCancelModal(e, rowData)}
                          style={{ width: "50px", height: "35px", backgroundColor: "#800080" }}
                        >
                          <FontAwesomeIcon icon={faCalendarXmark} />
                        </Comp.Button>
                      </span>
                    )}
                    {rowData.STATUS === "E29288AB-B30C-4039-9365-0324498F1352" && (
                      <span title="Export">
                        <Comp.Button
                          id="btnExport"
                          type="general"
                          onClick={(e) => onExcelHandler(e, rowData)}
                          style={{ width: "50px", height: "35px", backgroundColor: "green" }}
                        >
                          <FontAwesomeIcon icon={faDownload} />
                        </Comp.Button>
                      </span>
                    )}
                  </div>
                )}
              />
            <Column
              header="#" 
              body={(rowData, options) => options.rowIndex + 1}
              style={{ width: '3rem', height: "40px", textAlign: 'center' }}
            />
            <Column field="USERNAME" header="Name" frozen filter filterPlaceholder="Search by name" sortable
              style={{ minWidth: isMobile ? '180px' : '220px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.USERNAME} keyword={rowData.__FILTER_KEYWORD__?.USERNAME || ''} />
              )}
            />
            <Column field="STATUS_DESC" header="Status" frozen={!isMobile} filter filterElement={statusFilterTemplate} sortable
              style={{ minWidth: '220px' }} 
              body={(rowData) => (
                <span className={`status-badge ${rowData.STATUS_DESC?.toLowerCase()}`}>
                <HighlightCell text={rowData.STATUS_DESC} keyword={rowData.__FILTER_KEYWORD__?.STATUS_DESC || ''} /></span>
              )}
            />
            <Column field="SUBMIT_DATETIME" header="Submitted On" sortable style={{ minWidth: '160px' }}
              sortFunction={(e) => {
                const parseDate = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                  );
                };

                const sorted = [...e.data].sort((a, b) => {
                  const dateA = parseDate(a.SUBMIT_DATETIME);
                  const dateB = parseDate(b.SUBMIT_DATETIME);

                  return (dateA - dateB) * e.order;
                });

                return sorted;
              }}
            />
            <Column field="LEAVE_TYPE" header="Leave Type" filter filterElement={leaveTypeFilterTemplate} sortable
              style={{ minWidth: '250px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.LEAVE_TYPE} keyword={rowData.__FILTER_KEYWORD__?.LEAVE_TYPE || ''} />
              )}
            />
            <Column field="LEAVE_SESSION" header="Leave Session" sortable style={{ minWidth: '100px' }}></Column>
            <Column field="START_DATE" header="Date From" sortable style={{ minWidth: '100px' }} bodyStyle={{ backgroundColor: '#dbeafe' }}
              sortFunction={(e) => {
                const parseDMY = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  let hours = 0, minutes = 0, seconds = 0;

                  if (timePart) {
                    [hours, minutes, seconds] = timePart.split(':').map(Number);
                  }

                  return new Date(
                    Number(year),
                    Number(month) - 1,
                    Number(day),
                    hours,
                    minutes,
                    seconds
                  );
                };

                return [...e.data].sort((a, b) =>
                  (parseDMY(a.START_DATE) - parseDMY(b.START_DATE)) * e.order
                );
              }}
            />
            <Column field="END_DATE" header="Date To" sortable style={{ minWidth: '100px' }} bodyStyle={{ backgroundColor: '#dbeafe' }}
              sortFunction={(e) => {
                const parseDMY = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  let hours = 0, minutes = 0, seconds = 0;

                  if (timePart) {
                    [hours, minutes, seconds] = timePart.split(':').map(Number);
                  }

                  return new Date(
                    Number(year),
                    Number(month) - 1,
                    Number(day),
                    hours,
                    minutes,
                    seconds
                  );
                };

                return [...e.data].sort((a, b) =>
                  (parseDMY(a.END_DATE) - parseDMY(b.END_DATE)) * e.order
                );
              }}
            />
            <Column field="TOTAL_DAYS" header="Total Day(s)" sortable style={{ minWidth: '100px' }} bodyStyle={{ backgroundColor: '#dbeafe' }}></Column>
            <Column field="REASON" header="Reason for Leave" sortable style={{ minWidth: '250px' }}
              body={(rowData) => 
                <TruncatedText text={rowData.REASON} maxLength={50} />
              }
            />
            <Column field="ATTACHMENT_ID" header="Supporting Doc" style={{ minWidth: '150px' }}
              body={(rowData) => {
                const ids = rowData.ATTACHMENT_ID
                  ? rowData.ATTACHMENT_ID.split(",").map((id) => id.trim()).filter(id => id)
                  : [];

                const names = rowData.FILENAME_ORI
                  ? rowData.FILENAME_ORI.split(",").map((x) => x.trim())
                  : [];

                return (
                  <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "4px" }}>
                    {rowData.STATUS === "2F917D27-2274-4509-9B9C-1A86FFFB6A45" && rowData.LEAVE_TYPE === "Medical" && rowData.ATTACHMENT_ID === null ? (
                      <span title="Upload">
                        <Comp.Button
                          id="btnUpload"
                          type="general"
                          onClick={(e) => showUploadModal(e, rowData)}
                          style={{ width: "50px", height: "35px" }}
                        >
                          <FontAwesomeIcon icon={faUpload} />
                        </Comp.Button>
                      </span>
                    ) : (
                      ids.map((id, idx) => (
                        <span
                          key={idx}
                          title={`Download ${names[idx]}`}
                          style={{
                            color: "#8A2BE2",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => onImageHandler(e, { ATTACHMENT_ID: id })}
                        >
                          <FcImageFile
                            className="fa fa-paperclip"
                            style={{ width: 36, height: 36 }}
                          />
                        </span>
                      ))
                    )}
                  </div>
                );
              }}
            />
            <Column field="COVER_NAME" header="Cover By" sortable style={{ minWidth: '250px' }}
              body={(rowData) => 
                <TruncatedText text={rowData.COVER_NAME} maxLength={50} />
              }
            />
            <Column field="REMARK" header="Reject / Cancel Reason" sortable style={{ minWidth: '250px', textAlign: 'left' }} 
              bodyStyle={{ backgroundColor: '#ffd9d9', color: '#c00000' }}
              body={(rowData) => 
                <TruncatedText text={rowData.REMARK} maxLength={50} />
              }
            />
            <Column field="UPDATE_DATETIME" header="Last Update" sortable style={{ minWidth: '160px' }}
              sortFunction={(e) => {
                const parseDate = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                  );
                };

                const sorted = [...e.data].sort((a, b) => {
                  const dateA = parseDate(a.UPDATE_DATETIME);
                  const dateB = parseDate(b.UPDATE_DATETIME);

                  return (dateA - dateB) * e.order;
                });

                return sorted;
              }}
            />
            <Column field="UPDATE_NAME" header="Updated By" sortable style={{ minWidth: '150px' }}></Column>
          </DataTable>
        </div>
      </div>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
      <LeaveApprove
        page={props.page}
        module={MODULE_ID}
        showHide={showApprove}
        editData={editData}
        onHide={hideApproveModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <LeaveRejected
        page={props.page}
        module={MODULE_ID}
        showHide={showRejected}
        editData={editData}
        onHide={hideRejectedModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <LeaveCancel
        page={props.page}
        module={MODULE_ID}
        showHide={showCancel}
        editData={editData}
        onHide={hideCancelModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <AttachmentReminder
        page={props.page}
        module={MODULE_ID}
        showHide={showReminder}
        editData={editData}
        onHide={hideReminderModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <AttachmentUpload
        page={props.page}
        module={MODULE_ID}
        showHide={showUpload}
        editData={editData}
        onHide={hideUploadModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
    </>
  );
};

export default LeaveHistory;
